<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <CiSkeletonItem class="h-[306px]" />
</template>

<style></style>
